import { CookieService } from 'ngx-cookie-service';
import { PaiementObj } from './../models/paiementObj.model';
import { Subscription } from 'rxjs';
import { OrangeService } from './../../views/paiement/orange.service';
import { AutreService } from './autre.service';
import { ConfigService } from 'ngx-envconfig';
import { MatSnackBar } from '@angular/material';
import { AppLoaderService } from './app-loader/app-loader.service';
import { Injectable } from '@angular/core';
import { Orange } from '../models/orange.model';
import { OrangeObject } from '../models/orangeobject.model';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class OmService {

  tokenOmSub: Subscription;
  paid: Subscription;

  constructor(
    private logger: NGXLogger,
    private loader: AppLoaderService,
    private snack: MatSnackBar,
    private autreService: AutreService,
    private configService: ConfigService,
    private orangeService: OrangeService,
    private cookieService: CookieService

  ) { }


  /**
   * Fonction pour obtenir le token et initialisé la session de OMPAY
   * @param orange
   * @param paiementObj
   */
  getTokenOmpay(orange: Orange, paiementObj: PaiementObj) {

    this.logger.trace('Objets entrants, orange ', orange, ' paiementObj ', paiementObj);

    this.tokenOmSub = this.orangeService.getTokenOmpay(orange)
    .subscribe(data => {

      this.logger.trace('data', data);
      let statuscode = data.status;

      switch (statuscode) {
        case 200: {
          let tokenOmPay = data.body;
          orange.token = tokenOmPay.trim();
          this.logger.trace('tokenPaiementOMPAY' +  orange.token);

          let tokenPaiement = this.autreService.genererToken(paiementObj.idpanier, paiementObj.apiKey, paiementObj.idcustomer);


          // Enregistrer les cookies
          let obj = '{"user": "'
          + paiementObj.user + '", "idcart": "'
          + paiementObj.idpanier + '","afid": "'
          + paiementObj.afid + '","idcustomer": "'
          + paiementObj.idcustomer + '","curl": "'
          + paiementObj.curlParam + '","isprestashop": "'
          + paiementObj.isprestashop + '","url": "'
          + paiementObj.urlfeedback + '","tokenpaiement": "'
          + tokenPaiement + '"}';
          // Save cookies
          this.logger.trace('ompayCookies' + orange.token);

          this.logger.trace('tokenPaiement' + tokenPaiement);

          this.cookieService.set( 'ompayCookies' + orange.token.trim(), obj, 0.04 );


          // Rediriger vers OMPAY
          let path = this.configService.get('redirectionVersOmpayUrl');
          let params = orange;
          let method = 'post';

          let orangeobject : OrangeObject = new OrangeObject();

          orangeobject.amount = orange.amount;
          orangeobject.merchantid = orange.merchantid;
          orangeobject.purchaseref = orange.purchaseref;
          orangeobject.sessionid = orange.sessionid;
          orangeobject.token = orange.token;



          this.logger.trace('gotoOrange ==============>');
          // this.orangeService.postForm('https://kyrmannpay.com/omphp/processpayment.php', params, method);
          this.paid = this.orangeService.goToOrange(orange).subscribe(data => {

            let statuscode = data.status;
            this.logger.trace('data from orange after payment', data);
            this.logger.trace('code status', statuscode);

            this.logger.trace('goFromOrange ==============>');

          });

          break;
        }
        case 204: {
          this.loader.close();
          this.snack.open('Impossible de generer le token, contacter l\'administrateur du site', 'OK', { duration: 4000 });
          let urlRetour = atob(paiementObj.urlfeedback);
          window.location.href = urlRetour; // Si echec
          break;
        }
        case 500: {
          this.loader.close();
          this.snack.open('Internal server error!', 'OK', { duration: 4000 });
          break;
        }
        default: {
          this.loader.close();
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 });
          break;
        }
      }
    },
    error => {
      let statuscode = error.status;
      this.logger.error('Erreur', error);
      this.logger.error('Erreur' + error.error, error);


      switch (statuscode) {
        case 404: {
          this.loader.close();
          this.snack.open('URL introuvable!', 'OK', { duration: 4000 });
          break;
        }
        case 500: {
          this.loader.close();
          this.snack.open('Internal server error!', 'OK', { duration: 4000 });
          break;
        }
        default: {
          this.loader.close();
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 });
          break;
        }

      }

    } );

  }

}
